function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 0H8.5C8.22344 0 8 0.223437 8 0.5C8 0.776563 8.22344 1 8.5 1H10.2922L7.14688 4.14687C6.95156 4.34219 6.95156 4.65938 7.14688 4.85469C7.24375 4.95156 7.37188 5.00156 7.5 5.00156C7.62812 5.00156 7.75625 4.95313 7.85312 4.85469L11 1.70781V3.5C11 3.77656 11.2234 4 11.5 4C11.7766 4 12 3.77656 12 3.5V0.5C12 0.223437 11.7766 0 11.5 0ZM4.14687 7.14688L1 10.2922V8.5C1 8.22344 0.776563 8 0.5 8C0.223437 8 0 8.22344 0 8.5V11.5C0 11.7766 0.223437 12 0.5 12H3.5C3.77656 12 4 11.7766 4 11.5C4 11.2234 3.77656 11 3.5 11H1.70781L4.85469 7.85312C5.05 7.65781 5.05 7.34062 4.85469 7.14531C4.65781 6.95156 4.34219 6.95156 4.14687 7.14688Z",
  fill: "#C4C4C4"
});
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.b7a42805a7fa29a0449c3851c22f1ff3.svg";
export { ForwardRef as ReactComponent };